import React, { useEffect, useRef, useState } from 'react';
import { useInView, useReducedMotion } from 'framer-motion';

// Counts from 0 to `value` once, when scrolled into view.
export default function CountUp({ value, suffix = '', duration = 1400 }) {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: '-40px' });
    const reduce = useReducedMotion();
    const [display, setDisplay] = useState(reduce ? value : 0);

    useEffect(() => {
        if (!inView || reduce) return;
        let raf;
        const start = performance.now();
        const tick = (now) => {
            const t = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - t, 3);
            setDisplay(Math.round(value * eased));
            if (t < 1) raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(raf);
    }, [inView, value, duration, reduce]);

    return (
        <span ref={ref}>
            {display.toLocaleString('en-US')}{suffix}
        </span>
    );
}
